<template>
  <v-card tile>
    <v-card-text>
      <h4 mt-2>LISTE DES DEMANDES DE CARBURANT A APPROUVER</h4>
      <v-divider></v-divider>
      <v-layout wrap>
        <v-flex class="text-xs-right" xs12 mt-2>
          <v-flex xs12>
            <v-layout row class="mb-4 mt-1">
              <v-flex md4 class="mr-1">
                <el-select
                  filterable
                  @change="filtrerChantier()"
                  @clear="clearSelectChantier()"
                  v-model="chantierS"
                  placeholder="Selectionner un Chantier"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in listeChantier"
                    :key="item.id"
                    :label="item.libelle"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </v-flex>

              <v-flex md4 class="mr-1" v-if="chantierS != ''">
                <el-select
                  clearable
                  filterable
                  @change="filtrerTravaux()"
                  v-model="travauxS"
                  placeholder="Selectionner un travaux"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in listeTravaux"
                    :key="item.idTravaux"
                    :label="item.libTravaux"
                    :value="item.idTravaux"
                  >
                  </el-option>
                </el-select>
              </v-flex>

              <v-flex md4 class="mr-1" v-if="travauxS != ''">
                <el-select
                  filterable
                  @change="filtrerTaches()"
                  v-model="tachesS"
                  placeholder="Selectionner une tâche"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in listeTaches"
                    :key="item.idTache"
                    :label="item.libTache"
                    :value="item.idTache"
                  >
                  </el-option>
                </el-select>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-tooltip top>
            <v-btn
              :disabled="disabledBtnValide"
              slot="activator"
              icons
              class="white--text"
              color="primary"
              @click.stop="modalValideBesoin()"
            >
              Approuver / Rejeter
              <v-icon right>done</v-icon> </v-btn
            >Valider les ressources sélectionées
          </v-tooltip>
        </v-flex>
        <v-flex xs12 mt-2>
          <data-tables
            mt-3
            ml-1
            mr-1
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            :data="BesoinsList"
            style="width:100%;"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <h3>Libelle du PROJET/CHANTIER/TRAVAUX/TACHE:</h3>
                <p>
                  {{ props.row.libelle }}
                </p>
                <h3>DEMANDEUR:</h3>
                <p>
                  {{ props.row.demandeur }}
                </p>
              </template>
              <!-- <el-table-column prop="demandeur" label="DEMANDEUR" align="center"></el-table-column> -->
            </el-table-column>
            <el-table-column width="55" type="selection"></el-table-column>
            <el-table-column
              prop="dateC"
              label="DATE DEMANDE"
              align="center"
            ></el-table-column>
            <el-table-column
              v-fi="typeReche != 'carburant'"
              prop="codeGestion"
              label="Code analytique"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="type"
              label="TYPE RESSOURCE"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="produit"
              label="RESSOURCE"
              align="center"
            ></el-table-column>
            <el-table-column prop="qte" label="QTE PREVU" align="center">
              <template slot-scope="scope">
                <v-chip outline text-color="orange" label>
                  {{ scope.row.qte }}
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column prop="qteC" label="QTE COMMANDE" align="center">
              <template slot-scope="scope">
                <v-chip outline text-color="green" label>
                  {{ scope.row.qteC }}
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column prop="qteR" label="QTE RESTANTE" align="center">
              <template slot-scope="scope">
                <v-chip outline text-color="red" label>
                  {{ scope.row.qteR }}
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column
              prop="unite"
              label="UNITE"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="priorite"
              sortable
              label="PRIORITE"
              align="center"
            >
              <template slot-scope="scope">
                <v-chip
                  text-color="white"
                  label
                  fab
                  color="green accent-3"
                  v-if="scope.row.priorite === 1"
                  >Faible
                </v-chip>
                <v-chip
                  text-color="white"
                  label
                  fab
                  color="orange accent-4"
                  v-else-if="scope.row.priorite === 2"
                  >Normal</v-chip
                >
                <v-chip
                  text-color="white"
                  label
                  fab
                  color="red accent-3"
                  v-else-if="scope.row.priorite === 3"
                  >Urgent</v-chip
                >
                <v-chip
                  text-color="white"
                  label
                  fab
                  color="blue lighten-4"
                  v-else
                  >Aucune</v-chip
                >
              </template>
            </el-table-column>

            <!-- <el-table-column prop="priorite" label="PRIORITE" align="center"></el-table-column> -->
            <el-table-column
              prop="duree"
              label="DATE SOUH / PERIODE D'UTILISATION"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="periode"
              label="PERIODE TRAVAUX"
              align="center"
            ></el-table-column>
          </data-tables>
        </v-flex>
      </v-layout>
    </v-card-text>
    <!-- MODAL VALIDATION BESOIN -->
    <!-- MODAL STOP TRAVAUX -->
    <v-layout row justify-center>
      <v-dialog v-model="dialogValideBesoin" persistent max-width="1160">
        <v-card>
          <v-card-title class="headline">
            VALIDATION DES DEMANDES DE CARBURANT SELECTIONNEES
          </v-card-title>
          <v-card-text class="mb-5">
            <el-alert
              :title="
                'Voulez-vous approuver ou rejeter Les ressources selectionnées '
              "
              description="Les demandes de carburant pour les véhicules seront traité par les entrepots de type HYDROLIQUE. Veuillez précisez la date de livraison souhaitée s'il vous plait et la mention bon pour accord dans le champs commentaire et sélectioner un Entrepot."
              type="warning"
              center
              :closable="false"
              show-icon
            >
            </el-alert>

            <!-- Listes des besoins selectionnes -->
            <el-table
              border
              highlight-current-row
              :header-row-style="headerRowStyle"
              :data="listeBesoinSelect"
              style="width: 100%; margin-top:30px"
            >
              <el-table-column
                align="center"
                prop="produit"
                label="DESIGNATION"
              >
              </el-table-column>

              <el-table-column
                align="center"
                prop="periode"
                label="PERIODE TRAVAUX"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="dateLivrSouh"
                label="DATE LIVRAISON SOUHAITEE"
              >
              </el-table-column>
              <el-table-column
                prop="dateLivrSouh"
                label="CHANGER DATE LIVRAISON *"
              >
                <template slot-scope="prop">
                  <div class="block">
                    <el-date-picker
                      style="width:100%"
                      format="dd-MM-yyyy"
                      value-format="dd-MM-yyyy"
                      id="dateLivrSouh"
                      v-model="prop.row.dateLivrSouh"
                      type="date"
                      placeholder="Choississez une date de livraison"
                    >
                    </el-date-picker>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="qteR" label="QUANTITE A COMMANDER *">
                <template slot-scope="prop">
                  <div class="block">
                    <el-input
                      type="number"
                      name="qteR"
                      @change="calculTotalComm(prop.row)"
                      v-model="prop.row.qteR"
                      style="width:100%"
                    ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="entrepot" label="ENTREPOT DE TRAITEMENT *">
                <template slot-scope="prop">
                  <div class="block">
                    <el-select
                      v-model="prop.row.entrepot"
                      placeholder="Selectionner l'entrepot"
                    >
                      <el-option
                        v-for="item in listEntrepot"
                        :key="item.value"
                        :label="item.libelle"
                        :value="item.id"
                        style="width:100%"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <el-form class="mt-4" label-position="top" label-width="120px">
              <el-form-item label="Commentaire *">
                <el-input
                  rows="6"
                  type="textarea"
                  v-model="commDec"
                  placeholder="Veuillez saisir l'expression bon pour accord si vous souhaitez valider la demande"
                >
                </el-input>
              </el-form-item>
            </el-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="dialogValideBesoin = false"
              >Annuler</v-btn
            >
            <v-btn
              :disabled="!verifBtnConfirme"
              color="green darken-1"
              @click="validRejetBesoin(1)"
              flat
              >Confirmer
            </v-btn>
            <v-btn
              :disabled="!verifBtnRefus"
              color="red darken-1"
              @click="validRejetBesoin(0)"
              flat
              >Rejeter</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- MODAL STOP TRAVAUX-->
  </v-card>
</template>

<script>
//liste l'ensemble  des besoins  ou les besoinsa valider par un responsable
import Loading from "@/components/Loading";

export default {
  components: { Loading },
  name: "BesoinCarburantResponsable",
  props: {
    show: {
      type: Boolean
    },
    typeReche: {
      type: String
    },
    idresponsable: {
      type: Number,
      default: null
    },
    listeTrx: {
      type: Array
    },
    listeBesoins: {
      type: Array
    },
    listeChantiers: {
      type: Array
    },
    idProjet: {
      type: Number
    }
  },
  data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      dialogValideBesoin: false,
      multipleSelection: [],
      //FILTRE
      listeProjet: [],
      listEntrepot: [],
      listeChantier: [],
      listeTravaux: [],
      listeTaches: [],
      travauxS: "",
      tachesS: "",
      BesoinsList: [],
      projetS: "",
      valide: false,
      chantierS: "",
      listeBesoinSelect: [],
      disabledBtnValide: true,
      commDec: null
    };
  },
  watch: {
    show: function(newValue, oldvalue) {
      if (newValue == true) {
        //this.oldListTravaux = this.listeTrx;
      }
    },
    listeBesoins: function(newValue, oldvalue) {
      this.BesoinsList = this.listeBesoins;
      this.listeChantier = this.listeChantiers;
    }
  },
  methods: {
    //FILTRE
    loadProjet() {
      this.chantierS = "";
      this.listeChantier.splice(0);
      this.chantierS = null;
      let url = this.domaine + "projet/index/projet/all";
      this.loading = true;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listeProjet = response.body.projet;
        },
        error => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste des projets"
          );
        }
      );
    },
    loadTravaux() {
      this.loading = true;
      let url = this.domaine + "projet/" + this.idProjet + "/all/travaux";
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listeChantier = response.body.chantier;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste du chntier"
          );
        }
      );
    },

    filtrerChantier() {
      let idChant = this.chantierS;
      if (idChant == null || idChant == "undefined" || idChant == "") {
        this.BesoinsList = this.listeBesoins;
        // this.filtrerChantier()
        return;
      }
      this.BesoinsList = this.listeBesoins.filter(function(item) {
        return item.idChant == idChant;
      });
      var tableau = this.listeBesoins.filter(function(item) {
        return item.idChant == idChant;
      });
      for (var i = 0; i < tableau.length; ++i) {
        for (var j = i + 1; j < tableau.length; ++j) {
          if (tableau[i].idTravaux === tableau[j].idTravaux) {
            tableau.splice(j--, 1);
          }
        }
      }

      this.listeTravaux = tableau;
    },
    calculTotalComm(item) {
      this.valide = false;
      let restant = item.qte - item.qteC;
      if (restant < item.qteR) {
        this.valide = true;
        this.$message.error(
          "La quantité demandé ne dois pas etre supérieur a la quantité prévu "
        );
      }
    },
    filtrerTravaux() {
      let travauxS = this.travauxS;
      this.listeTaches = [];
      if (travauxS != "") {
        this.BesoinsList = this.listeBesoins;
      }
      if (travauxS == null || travauxS == "undefined" || travauxS == "") {
        this.BesoinsList = this.listeBesoins;
        // this.filtrerChantier()
        return;
      }

      var tab = this.BesoinsList;
      this.BesoinsList = tab.filter(function(item) {
        return item.idTravaux == travauxS;
      });

      var tableau = tab.filter(function(item) {
        return item.idTravaux == travauxS;
      });
      for (var i = 0; i < tableau.length; ++i) {
        for (var j = i + 1; j < tableau.length; ++j) {
          if (tableau[i].idTache === tableau[j].idTache) {
            tableau.splice(j--, 1);
          }
        }
      }
      this.listeTaches = tableau;
    },
    filtrerTaches() {
      let idTache = this.tachesS;
      if (idTache == null || idTache == "undefined" || idTache == "") {
        //  this.BesoinsList = this.listeBesoins;
        this.filtrerTravaux();
        this.filtrerChantier();
        return;
      }
      this.filtrerChantier();
      var tab = this.BesoinsList;
      this.BesoinsList = tab.filter(function(item) {
        return item.idTache == idTache;
      });
    },
    modalValideBesoin() {
      this.listeBesoinSelect = this.multipleSelection.slice();
      this.dialogValideBesoin = true;
      this.loadEntrepot();
    },
    loadEntrepot() {
      this.loading = true;
      let url = this.domaine + "entrepot/index/carburant";
      this.$http.get(url).then(
        response => {
          this.loading = false;
          if (response.body) {
            this.listEntrepot = response.body.entrepot;
          }
        },
        error => {
          this.loading = false;
        }
      );
    },
    imprimeAllBesoins(item) {
      let url =
        this.domaine +
        "projet/impression/all/besoins/" +
        this.user.id +
        "/" +
        this.idProjet;
      window.open(url);
    },
    validRejetBesoin(decision) {
      if (this.valide == true) {
        this.$notify({
          title: "ENREGISTREMENT ECHOUE",
          message: "QUANTITE RENSSEIGNEE SUPERIEUR A LA QUANTITE PREVU.",
          type: "warning",
          position: "top-center"
        });
        return;
      }
      this.loading = true;

      //decision == 1 = Valider // decision == 0 //Refuser
      let url = this.domaine + "besoin/avalider";
      let nbData = 10;
      let nbReq = 1;
      let ligne = null;
      let nbRest;
      if (this.listeBesoinSelect.length > 10) {
        nbData = 10;
        nbReq = Math.round(this.listeBesoinSelect.length / nbData);
        nbRest = this.listeBesoinSelect.length % nbData;
        if (nbRest > 0) {
          nbReq += 1;
        }
      }
      for (let i = 0; i < nbReq; i++) {
        let initJ = i * nbData;
        let finJ = (i + 1) * nbData;
        let dataLot = [];
        if (this.listeBesoinSelect.length > 0) {
          for (let j = initJ; j < finJ; j++) {
            if (this.listeBesoinSelect[j] == undefined) {
              break;
            }
            dataLot.push(this.listeBesoinSelect[j]);
          }
        }
        let data = new FormData();
        for (let prop in dataLot) {
          ligne = dataLot[prop];
          data.append("option[id][]", ligne.id);
          data.append("option[dateLivrSouh][]", ligne.dateLivrSouh);
          data.append("option[qteR][]", ligne.qteR);
          data.append("option[entrepot][]", ligne.entrepot);
        }
        data.append("decision", decision);
        data.append("commDec", this.commDec);
        data.append("type", this.typeReche);
        data.append("idUser", this.user.id);

        this.$http.post(url, data).then(
          resp => {
            this.dialogValideBesoin = false;
            this.loading = false;
            this.$emit("reloadBesoins");
            this.$notify({
              title: "Validation besoins",
              message: "L'opération s'est déroulée avec succès",
              type: "success",
              position: "top-center"
            });
          },
          error => {
            this.dialogValideBesoin = false;
            this.loading = false;
            this.$message.error(
              "Erreur lors du chargement de la validation des besoins"
            );
          }
        );
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnValide = true;
      } else {
        this.disabledBtnValide = false;
      }
    },
    headerRowStyle({ row, rowIndex }) {
      return { color: "black" };
    }
  },
  computed: {
    verifDateSouh: function() {
      let resutat = true;
      for (let prop in this.listeBesoinSelect) {
        let ligne = this.listeBesoinSelect[prop];

        if (
          ligne["dateLivrSouh"] == null ||
          ligne["dateLivrSouh"] == undefined
        ) {
          resutat = false;
          break;
        }
      }
      return resutat;
    },
    clearSelectTache() {
      // this.tachesS = ''
      this.filtrerTravaux();
    },
    clearSelectTravaux() {
      // this.travauxS = ''
      this.filtrerChantier();
    },
    clearSelectChantier() {
      this.chantierS = "";
      this.loadProjet();
    },
    verifBtnConfirme: function() {
      if (
        this.verifDateSouh == true &&
        this.commDec != null &&
        this.commDec.toUpperCase() == "BON POUR ACCORD"
      ) {
        return true;
      }
      return false;
    },

    verifBtnRefus: function() {
      if (this.commDec != null) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.chantierS = "";
  }
};
</script>



// WEBPACK FOOTER //
// src/components/besoin/besoinCarburantResponsable.vue